import { api } from './client';

export const fornecedoresApi = {
  listar: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return api.get(`/fornecedores${qs ? `?${qs}` : ''}`);
  },
  obter: (id) => api.get(`/fornecedores/${id}`),
  criar: (dados) => api.post('/fornecedores', dados),
  atualizar: (id, dados) => api.put(`/fornecedores/${id}`, dados),
  remover: (id) => api.del(`/fornecedores/${id}`),
  obterContatos: (id) => api.get(`/fornecedores/${id}/contatos`),
  salvarContatos: (id, itens) => api.put(`/fornecedores/${id}/contatos`, { itens })
};
